import React, { useMemo } from 'react';
import { Box, Image } from '@common-fe/common-fe';
import styled from 'styled-components';

import expressSetupSignUpSidebar from '@/assets/placeholders/express-setup-sign-up-sidebar.svg';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';
import { THEMES } from '@/utils/whiteLabeling/whiteLabelingConfig';

export const IllustrationWrapper = styled(Box)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: ${({ theme }) => theme.spacings.spacing8};
`;

interface Props {
  testId?: string;
  largeLogoUrl?: string;
  darkLargeLogoUrl?: string;
}

const Sidebar: React.FC<Props> = ({ testId, largeLogoUrl, darkLargeLogoUrl }) => {
  const logoUrl = useMemo(() => {
    if (whiteLabelingConfig?.key === THEMES.apprize || whiteLabelingConfig?.key === THEMES.rmr) {
      return darkLargeLogoUrl;
    }

    return largeLogoUrl;
  }, [largeLogoUrl, darkLargeLogoUrl]);

  const illustrationSrc = useMemo(() => {
    if (!whiteLabelingConfig.key) {
      return expressSetupSignUpSidebar;
    }
  }, []);

  return (
    <Box
      data-testId={`${testId}_sidebar`}
      width="340px"
      height="100vh"
      pad="spacing32"
      background="navigationBackground"
      style={{ position: 'sticky', top: 0 }}
    >
      <Image
        fit="contain"
        style={{ maxWidth: 170, maxHeight: 34 }}
        alt="logo"
        src={logoUrl}
      />

      {illustrationSrc && (
        <IllustrationWrapper>
          <Image src={illustrationSrc} />
        </IllustrationWrapper>
      )}
    </Box>
  );
};

export default Sidebar;
